const NES_MESSAGE_TRANSLATIONS = {
    nl: {
        success: 'Succes',
        informative: 'Informatief',
        warning: 'Waarschuwing',
        error: 'Error',
        'error-heavy': 'Error',
        close: 'Sluit bericht',
    },
    en: {
        success: 'Success',
        informative: 'Informative',
        warning: 'Warning',
        error: 'Error',
        'error-heavy': 'Error',
        close: 'Close message',
    },
};

export { NES_MESSAGE_TRANSLATIONS as N };
